import { defineComponent as _defineComponent } from 'vue'
import { ChartGenerator } from '@/models/Charts/abstract/chartGenerator';
import { PeakHourlyBendingData } from '@/models/Charts/chartsData';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import KpiWidget from '../common/KpiWidget.vue';
import { isEmpty, isNil, maxBy } from '@/utils/misc';
import { computed } from 'vue';
import { TrendData } from '@/components/bend/kpiWidgetUtils';
import { devicesService } from '@/services/devices.service';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'PeakHourlyBendingWidget',
  props: {
    data: null,
    generator: null,
    widgetDefinition: null,
    loading: { type: Boolean },
    isFetchingForTheFirstTime: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  data: PeakHourlyBendingData | null;
  generator: ChartGenerator<PeakHourlyBendingData>;
  widgetDefinition: WidgetDefinition;
  loading: boolean;
  isFetchingForTheFirstTime: boolean;
};



const { t } = useI18n();

const trendData = computed<TrendData | null>(() => {
  // FIXME: Ideally we'd have an isNil check here, but SingleWidgetContainer
  //   converts null into an empty object {}. This comes from before splitting
  //   it from Chart, where this made sense to show the 'No data' message.
  //   SingleWidgetContainer should be changed to pass the null instead and
  //   Chart should be adapted accordingly. Maybe it'd be better to pass a
  //   loading property and avoid the {} altogether.
  if (isEmpty(props.data)) {
    return null;
  }

  const currentPeriodBestPeakEntry = maxBy(
    props.data!.currentPeriodBestPeaks,
    (item) => item.value,
  );

  return {
    currentValue: currentPeriodBestPeakEntry?.value ?? 0,
    currentValueDateTime: !isNil(currentPeriodBestPeakEntry)
      ? new Date(currentPeriodBestPeakEntry.dateTime)
      : null,
    currentValueDeviceName: !isNil(currentPeriodBestPeakEntry)
      ? getDeviceName(currentPeriodBestPeakEntry.deviceStringId)
      : null,

    previousValue: props.data!.previousPeriodPeak?.value ?? 0,
    previousValueDateTime: !isNil(props.data!.previousPeriodPeak?.dateTime)
      ? new Date(props.data!.previousPeriodPeak!.dateTime)
      : null,
    previousValueDeviceName: !isNil(
      props.data!.previousPeriodPeak?.deviceStringId,
    )
      ? getDeviceName(props.data!.previousPeriodPeak!.deviceStringId)
      : null,

    timeSpan: props.widgetDefinition.timeFilterEnumValue!,
    chartType: 'bar',
  };
});

function getDeviceName(id: string): string {
  return devicesService.store.getNameByStringId(id)!;
}

return { __sfc: true,props, t, trendData, getDeviceName, KpiWidget }
}

})